import React, { useState } from "react";
import { Eye, Copy } from "lucide-react";
import { FileFailureType, FileFailureTypeColors, FileFailureTypeIcons, FileFailureTypeLabels } from "../../../../models/FileFailureType";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";

import { dialogMedium } from "@/lib/dialogSize";

interface FileFailureTypeChipProps {
  failureType: FileFailureType;
  failureReason: string;
  style?: React.CSSProperties;
}

export const FileFailureTypeChip: React.FC<FileFailureTypeChipProps> = ({
  failureType,
  failureReason,
  style,
}) => {
  const [open, setOpen] = useState(false);
  const handleCopy = () =>
    navigator.clipboard.writeText(failureReason);

  const Icon = FileFailureTypeIcons[failureType];

  return (
    <>
      {failureType != FileFailureType.None && (
        <>
          <div className="flex items-center gap-2">
            <Badge
              variant={FileFailureTypeColors[failureType]}
              style={style}
            >
              {Icon && <Icon className="size-3" />}
              {FileFailureTypeLabels[failureType]}
            </Badge>
            <Button
              variant="ghost"
              size="icon-xs"
              onClick={() => setOpen(true)}
            >
              <Eye className="size-4" />
            </Button>
          </div>
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent className={`${dialogMedium} flex flex-col overflow-hidden`}>
              <DialogHeader>
                <DialogTitle>Failure Reason</DialogTitle>
              </DialogHeader>
              <Separator />
              <div className="overflow-y-auto whitespace-pre-wrap font-mono text-sm">
                {failureReason}
              </div>
              <Separator />
              <DialogFooter>
                <Button
                  variant="outline"
                  onClick={handleCopy}
                >
                  <Copy className="size-4" />
                  Copy
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </>
      )}
    </>
  );
};
